import { axiosService } from './axiosService';

const auth = () => axiosService.setAuth(true);

const unwrap = async (req: Promise<any>) => {
  try {
    const { data } = await req;
    return { ok: true, data: data?.data ?? data, raw: data };
  } catch (error: any) {
    const message =
      (error?.response?.data?.message) || error?.message || 'Request failed';
    return { ok: false, error: message };
  }
};

export const kycService = {
  list: (status: string, userKind: string, page = 1, limit = 20) =>
    unwrap(auth().get(`user/kyc/admin/submissions?status=${status || ''}&userKind=${userKind || ''}&page=${page}&limit=${limit}`)),
  approve: (userId: string) => unwrap(auth().patch(`user/kyc/admin/${userId}/approve`)),
  reject: (userId: string, reason: string) => unwrap(auth().patch(`user/kyc/admin/${userId}/reject`, { reason })),
};
